import axios from "@/api/bqpyApi";
let method = 'GET';
/*培育系统APP经营行业*/
export const pyfdAppOperatingIndustry=data=>axios.get('/pyfdAppOperatingIndustry',data)
/*培育系统APP经营行业*/
export const pyfdAppSaveHighQualitySystem=data=>axios.post('/pyfdAppSaveHighQualitySystem',data)
export const pyfdAppSaveSmesRResourcePool=data=>axios.post('/pyfdAppSaveSmesRResourcePool',data)
export const pyfdAppRegistrationType=data=>axios.get('/pyfdAppRegistrationType',data)
export const pyfdAppKeyPolicyWarehousing=data=>axios.post('/pyfdAppKeyPolicyWarehousing',data)